module.exports = __webpack_public_path__ + "static/media/4_l_taxi_3.07_83.7.b94ce5c4.png";